import { DefaultSet } from './default'

class DefaultPermissionHelper extends DefaultSet {
    code: string
    name: string

    constructor(code: string, name: string) {
        super()
        this.code = code
        this.name = name
    }
}

class Profile extends DefaultPermissionHelper {}
class Brand extends DefaultPermissionHelper {}
class Application extends DefaultPermissionHelper {
    icon: string
    title: string
    children: Application[]
    path: string

    constructor(data?: any) {
        if (data) {
            super(data.code, data.name)
            this.icon = data.icon
            this.children = data.list
            this.path = data.path
            this.title = data.title
        } else {
            super('', '')
            this.icon = ''
            this.children = []
            this.path = ''
            this.title = ''
        }
    }
}
export class Portal extends DefaultPermissionHelper {
    code: string
    name: string
    applications: Application[]
    url: string

    constructor(data?: any) {
        if (data) {
            super(data.code, data.name)
            this.code = data.code
            this.name = data.name
            this.applications = data.applications
            this.url = data.url
        } else {
            super('', '')
            this.code = ''
            this.applications = []
            this.name = ''
            this.url = ''
        }
    }
}

class Permission {
    retail_brand: string
    applications: Application[]

    constructor(data?: any) {
        this.retail_brand = data?.retail_brand ? data?.retail_brand : ''
        this.applications = data?.applications ? data.applications : []
    }
}

export class UserPermissions extends DefaultSet {
    profile: Profile
    retail_brands: Brand[]
    portals: Portal[]
    selectedPortal?: string

    constructor(data?: any) {
        super()
        this.profile = new Profile('', '')
        this.retail_brands = [new Brand('', '')]
        this.portals = [new Portal()]
        if (data) {
            this._set(data)
        } else {
            // this._set(Permissions.mockPermissions());
        }
    }

    static mockPermissions = () => {
        let profile: Profile = new Profile('SMM', 'Store Manager')
        let retail_brands: Brand[] = [new Brand('SG', 'Sunglass Hut')]
        let applications: Application[] = [
            new Application({
                code: 'PM',
                name: 'Picture Management',
                icon: 'camera_alt',
                path: '/picture-mgmt',
                children: [],
            }),
            new Application({
                code: 'SVT',
                name: 'Store Visit Tool',
                icon: 'settings',
                path: '',
                children: [],
            }),
        ]

        return new UserPermissions({
            profile: profile,
            retail_brands: retail_brands,
            permission: applications,
        })
    }
}

export enum ActionTypes {
    smart_generic_action = 'smart_generic_action',
}

export enum ActionItems {
    Item = 'Item',
    Smartly = 'Smartly',
}

export interface ActionsState {
    actions: string[]
}

export enum SmartlyActionTypes {
    SAVEDRAFT = 'savedraft',
    CREATE = 'create',
    CREATE_AS_DRAFT = 'createasdraft',
    CREATE_RELEASED = 'createreleased',
    CANCEL = 'cancel',
    SEND_TO_RELEASE = 'sendtorelease',
    RELEASE = 'release',
    CLONE = 'clone',
    CLOSE = 'close',
    CLOSE_PHOTO = 'closephoto',
    REDO = 'redo',
    DELEGATE = 'delegate',
    REJECT = 'reject',
    EXECUTE_QUESTION = 'executequestion',
    EXECUTE_JOB = 'executejob',
    EXECUTE_SURVEY = 'executesurvey',
    CONFIRM_READING = 'confirmreading',
    EDIT = 'edit',
    SENDINAPPROVAL = 'sendinapproval',
    SENDINAPPROVAL_PHOTOGRAPHIC_TASK = 'sendinapprovalphotographictask',
    RECALL = 'recall',
    DELETE = 'delete',
    MOVE = 'move',
    MENU = 'menu',
    VIEW_REPORTS = 'viewreports',
    PROFILE_MGMT = 'editprofiles',
    ACCEPT_EXECUTION = 'acceptexecution',
    ACCEPT_APPROVAL = 'acceptapproval',
    UPLOAD_PHOTO = 'uploadphoto',
    GO_TO_GALLERY = 'gotogallery',
    PHOTO_APPROVAL = 'photoapproval',
    PROJECT_PHOTO_APPROVAL = 'projectphotoapproval',
    GALLERY_PHOTO_APPROVAL = 'galleryphotoapproval',
    PHOTO_REJECT = 'photoreject',
    PROJECT_PHOTO_REJECT = 'projectphotoreject',
    GALLERY_PHOTO_REJECT = 'galleryphotoreject',
    PHOTO_PUBLISH = 'photopublish',
    PROJECT_PHOTO_PUBLISH = 'projectphotopublish',
    GALLERY_PHOTO_PUBLISH = 'galleryphotopublish',
    GALLERY_PHOTO_SEND_IN_APPROVAL = 'galleryphotosendinapproval',
    PHOTO_SEND_IN_APPROVAL = 'photosendinapproval',
    VIEW_INFO_EXTRA = 'viewinfoextra',
    EDIT_ALIAS = 'editalias',
    MISTERY_VISIT_DISABLED = 'mysteryvisitdisabled',
}

export enum SmartlyActionItems { // project type
    TASK = 'task',
    NEWS = 'news',
    FORM = 'form',
    MENU = 'menu',
    PHOTO = 'photo',
    ALBUM = 'album',
    TOPIC = 'topic',
    THREAD = 'thread',
    MESSAGE = 'message',
    REPORTS = 'reports',
    DOCUMENT = 'document',
    RESOURCE = 'resource',
    QUICK_LINK = 'quicklink',
    PROFILE_MGMT = 'profilemgmt',
    VISIT = 'visit',
    CHALLENGE = 'challenge',
}

export enum SmartlyActionSubtypes { // project subtype
    PROFILE_MGMT = 'profilemgmt',
    COMMUNICATION = 'communication',
    PICTURE_MGMT = 'photographic',
    SERVICE_REQUEST = 'serviceRequest',
}
